import client from 'providers/fetchClient'
import { translateGiftCardPaymentStatus } from 'utils/translators'

export const getCardTypes = async ({ sortBy, pagination, search, orderId, ...filters }) => {
  const params = { search, ...filters }

  if (sortBy && sortBy.length) {
    params.ordering = sortBy.map(({ id, desc }) => (desc ? `-${id}` : id)).join(',')
  }

  if (pagination) {
    params.page = pagination.currentPage
    params.limit = pagination.pageSize
  }

  if (orderId) {
    params.order_id = orderId
  }

  const { data } = await client.get('/gift-cards', { params })

  return {
    cards: data.data,
    pagination: {
      pageSize: data.limit,
      currentPage: data.page,
      totalPages: data.total_pages,
      totalRecords: data.total,
    },
  }
}

export const createValueGiftCard = value => client.post('/gift-card-types', value)

export const createPlanGiftCard = plans => client.post('/gift-card-types-plans', plans)

export const editCardValue = (id, value) => client.put(`/gift-card-types/${id}`, value)

export const deleteValueGiftCard = id => client.delete(`/gift-card-types/${id}`)

export const deletePlansGiftCard = id => client.delete(`/gift-card-types-plans/${id}`)

export const postCardOrder = value => client.post('/orders', value)

export const getOrdersList = async ({ sortBy, pagination, search, ...filters }) => {
  const params = { search, ...filters }

  if (sortBy && sortBy.length) {
    params.ordering = sortBy.map(({ id, desc }) => (desc ? `-${id}` : id)).join(',')
  }

  if (pagination) {
    params.page = pagination.currentPage
    params.limit = pagination.pageSize
  }

  const { data } = await client.get('/orders', { params })

  const orders = data.data.map(order => ({
    ...order,
    gift_cards_balance: `${order.used_gift_cards}/${order.total_gift_cards}`,
    transaction_status: translateGiftCardPaymentStatus(order.transaction_status),
    boleto: order.transactions?.[0]?.boletos?.[0]?.payment_url,
    receipt: order.transactions?.[0]?.boletos?.[0]?.receipt,
  }))

  return {
    orders,
    pagination: {
      pageSize: data.limit,
      currentPage: data.page,
      totalPages: data.total_pages,
      totalRecords: data.total,
    },
  }
}

export const getGiftCardOrder = id => client.get(`/orders/${id}`)

export const getListOfOrderCards = async ({ id, sortBy, pagination, search, ...filters }) => {
  const params = { search, ...filters }

  if (sortBy && sortBy.length) {
    params.ordering = sortBy.map(({ id, desc }) => (desc ? `-${id}` : id)).join(',')
  }

  if (pagination) {
    params.page = pagination.currentPage
    params.limit = pagination.pageSize
  }

  const { data } = await client.get('/orders/coupon-history', {
    params: {
      order: id,
      ...params,
    },
  })

  return {
    cards: data?.data,
    pagination: {
      pageSize: data.limit,
      currentPage: data.page,
      totalPages: data.total_pages,
      totalRecords: data.total,
    },
  }
}

export const exportCSV = id =>
  client.get('/coupons/export-csv', {
    params: {
      order_id: id,
    },
  })
